import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListCollectionSubtitlesRequest } from './list-collection-subtitles-request';
import type { IListCollectionSubtitlesResponse } from './list-collection-subtitles-response';
import { listCollectionSubtitlesResponseSchema } from './list-collection-subtitles-response';

export async function listCollectionSubtitlesApi(
  params?: IListCollectionSubtitlesRequest,
): Promise<IValidatedResponse<IListCollectionSubtitlesResponse>> {
  const queryParams: Record<string, string | number> = {};
  if (params?.collectionId) {
    queryParams.collectionId = params.collectionId;
  }
  if (params?.query) {
    queryParams.query = params.query;
  }
  if (params?.cursor) {
    queryParams.cursor = params.cursor;
  }

  return getRequest<IListCollectionSubtitlesResponse>({
    path: '/sys/subtitles',
    schema: listCollectionSubtitlesResponseSchema,
    options: { params: Object.keys(queryParams).length > 0 ? queryParams : undefined },
  });
}
